module.exports = __webpack_public_path__ + "img/camera-polaroid.32129806.svg";